import React from 'react';
import style from './style/modalbackground.scss';

/**
 * Modal Background
 * - Provides overlay component for use as a modal background
 * - triggers provided method on click
 * @param {Object} props - props
 * @returns {*} Index
 * */
export default function ModalBackground(props) {
    const { closeModal, classes = { modalBackground: '' } } = props;

    return (
        <div
            className={ `${style.modalBackground} ${classes.modalBackground}` }
            role="button"
            tabIndex="-1"
            onClick={ event => {
                closeModal(event);
            }}
        />
    );
}
